<template>
	<div class="step1">
		<div class="content">
			<label class="header">Select an Appointment Type to See Availability</label>
			<div class="options">
				<input type="radio" id="FollowUp" value="FollowUp" v-model="type">
				<label for="FollowUp"><strong>FOLLOW-UP</strong> - CURRENT PATIENTS (30 MIN.)</label>
				<br>
				<input type="radio" id="FreeConsultation" value="FreeConsultation" v-model="type">
				<label for="FreeConsultation"><strong>FREE CONSULTATION</strong> - NEW PATIENTS (90 MIN.)</label>
			</div>
			<template v-if="type">
				<div class="date">
					<button @click="changeMonth('prev', true)">
						<img alt="back" src="images/left-arrow-white.svg"/>
					</button>
					<label> {{ calendar.month }} {{ calendar.year }}</label>
					<button @click="changeMonth('next', true)">
						<img alt="next" src="images/right-arrow-white.svg"/>
					</button>
				</div>
				<div class="weeks">
					<button class="action" @click="changeWeek('prev')">
						<img alt="back" src="images/left-arrow-gray.svg"/>
					</button>
					<div class="days">
						<button v-for="day in calendar.week" 
								class="day" :class="[getDayState(day), {'out-of-bounds': day.month !== calendar.month}]"
								:disabled="day.month !== calendar.month"
								@click="selectDay(day)">
							<label>{{ day.title }}</label>
							<label>{{ helpers().formatterDayShorthand(day.date) }}</label>
						</button>
					</div>
					<button class="action" @click="changeWeek('next')">
						<img alt="next" src="images/right-arrow-gray.svg"/>
					</button>
				</div>
				<div class="timeslots">
					<button v-for="timeslot in activeDay.timeslots" 
							:class="[{'active': selectedTimeslot === timeslot}]" 
							@click="selectedTimeslot = timeslot">
						{{ helpers().formatterTime(timeslot.dateTime) }}
					</button>
				</div>
				<label v-if="unavailable" class="notice">We are sorry, but we have no available appointments for this period. Please choose a different period</label>
			</template>
		</div>
		<div class="footer-actions">
			<button class="btn-beltone xl disabled">Back</button>
			<button class="btn-beltone xl" :class="{'disabled': selectedTimeslot === null}" @click="nextStep()" >Continue</button>
		</div>
		<label class="disclaimer">CAN'T FIND A DAY/TIME THAT WORKS FOR YOU? CALL US TO SCHEDULE AN APPOINTMENT.</label>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Services from '../../mixins/services';
import moment from 'moment';

export default {
	mixins: [Services],
	props: ['clinicId'],
	components: {
	},
	data: function () {
		return {
			type: '',
			today: moment().format('MM/DD/YYYY'),
			date: moment().format('MM/DD/YYYY'),
			calendar: null,
			unavailable: false,
			activeDay: {
				date: null,
				timeslots: [],
			},
			selectedTimeslot: null
		}
	},
	watch: {
		date() {
			this.getAppointmentTimeslotsList()
		},
		type(val) {
			this.initial = true;
			this.updateAppointmentType(val)
			this.getAppointmentTimeslotsList(true);
		}
	},
	computed: mapState({
		appointmentType: state => state.OnlineScheduling.appointmentType,
		appointments: state => state.OnlineScheduling.appointments,
		clientToken: state => state.ClientToken.clientToken,
	}),
	methods: {
		...mapActions('OnlineScheduling', { updateLoading: 'updateLoading' }),
		...mapActions('OnlineScheduling', { updateTimeslot: 'updateTimeslot' }),
		...mapActions('OnlineScheduling', { updateAppointmentType: 'updateAppointmentType' }),
		...mapActions('OnlineScheduling', { getAppointmentTimeslots: 'getAppointmentTimeslots' }),
		...mapActions('OnlineScheduling', { updateStep: 'updateStep' }),
		nextStep() {
            if (this.selectedTimeslot !== null) {
                this.updateTimeslot(this.selectedTimeslot)
                this.updateStep(2);
            }
		},
		async getAppointmentTimeslotsList() {
			this.updateLoading(true);

			this.activeDay = {
				date: null,
				timeslots: []
			}
			
			this.calendar = this.OnlineSchedulingHelpers().buildCalendar({ date: this.date })
			await this.getAppointmentTimeslots({
				StartDate: moment(this.calendar.week.find(el => el.title === 'SUN').date, 'MM/DD/YYYY').toISOString(),
				EndDate: moment(this.calendar.week.find(el => el.title === 'SAT').date, 'MM/DD/YYYY').toISOString(),
				AppointmentType: this.appointmentType,
				ClinicId: this.clinicId,
				ClientToken: this.clientToken,
				cb: async () => {
					this.unavailable = false;
					this.selectedTimeslot = null;
					let foundTimes = false
					this.calendar.week.forEach((el) => {
						let _obj = this.appointments.find(apt => moment(apt.date).format('MM/DD/YYYY') === el.date);
						el.month = moment(el.date).format("MMMM")
						el.timeslots = _obj && moment(this.today).isBefore(el.date) ? _obj.timeslots : [];

						if (el.timeslots.length > 0 && el.month === this.calendar.month) {
							foundTimes = true;
							this.updateLoading(false);
						}
					})

					if (!foundTimes) {
						if (this.initial) {
							this.changeWeek('next', false)
						} else {
							this.unavailable = true;
							this.updateLoading(false);
						}
					} else {
						let day = this.calendar.week.find(el => el.timeslots.length > 0)
						this.selectDay(day);
						this.selectedTimeslot =this.activeDay.timeslots[0];
					}
				}
			})
		},
		getDayState(day) {
			if (day.date === this.activeDay.date) {
				return 'active';
			} else if (
				day.timeslots.length === 0 || 
				moment(day.date, 'MM/DD/YYYY').isBefore(moment().subtract(1, 'day')) ||
				moment(day.date, 'MM/DD/YYYY').format('MMMM') !== this.calendar.month ||
				moment(day.date, 'MM/DD/YYYY').format('YYYY') !== this.calendar.year
			) {
				return 'disabled';
			} else {
				return '';
			}
		},
		dayShorthand(date) {
			return moment(date, "MM/DD/YYYY").format('D')
		},
		changeMonth(dir, manual = false) {
			if (manual) {
				this.initial = false
			}
			if (dir === 'prev') {
				if (moment(this.date, "MM/DD/YYYY").isBefore(moment())) return;
				this.date = moment(this.date, "MM/DD/YYYY").startOf('month').subtract(1, 'months').format('MM/DD/YYYY')
			} else {
				this.date = moment(this.date, "MM/DD/YYYY").startOf('month').add(1, 'months').format('MM/DD/YYYY')
			}
		},
		changeWeek(dir, manual = false) {
			if (manual) {
				this.initial = false
			}
			if (dir === 'prev') {
				let _date = moment(this.date, "MM/DD/YYYY").endOf('week').subtract(1, 'weeks').format('MM/DD/YYYY')
				if (moment(_date, "MM/DD/YYYY").isBefore(moment())) return;
				
				let _weekEndMonth = moment(_date, "MM/DD/YYYY").endOf('week').format('MMMM');
				if (_weekEndMonth === this.calendar.month) {
					this.date = _date;
				} else {
					this.date = moment(this.calendar.month, "MMMM").startOf('month').subtract(1, 'day').format('MM/DD/YYYY');
				}
			} else {
				let _date = moment(this.date, "MM/DD/YYYY").startOf('week').add(1, 'weeks').format('MM/DD/YYYY')
				let _weekStartMonth = moment(_date, "MM/DD/YYYY").startOf('week').format('MMMM');
				if (_weekStartMonth === this.calendar.month) {
					this.date = _date;
				} else {
					this.date = moment(this.calendar.month, "MMMM").startOf('month').add(1, 'month').format('MM/DD/YYYY');
				}
			}
		},
		selectDay(day) {
			if (
				day.timeslots.length === 0 ||
				moment(day.date, 'MM/DD/YYYY').isBefore(moment().subtract(1, 'day')) ||
				moment(day.date, 'MM/DD/YYYY').format('MMMM') !== this.calendar.month ||
				moment(day.date, 'MM/DD/YYYY').format('YYYY') !== this.calendar.year
			) return
			this.selectedTimeslot = null;
			this.activeDay = {
				date: day.date,
				timeslots: day.timeslots
			}
		},
	},
	mounted() {
		this.type = 'FreeConsultation'
	}
}
</script>